<template>
  <div>
    <div id="change-pass">
      <v-parallax height="auto" src="@/assets/images/back-page.webp">
        <v-container>
          <v-row>
            <v-col>
              <div class="webform">
                <h3 class="text-center">¿Olvidaste tu contraseña?</h3>
                <p class="text-center txt-form">Ingresa una dirección de correo para enviarte el link de cambio de contraseña.</p>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-row justify="center" class="pa-0">
                        <v-col cols="12" sm="7" md="6" lg="5" class="pa-0">
                          <div class="card-login pa-0" ref="form">
                            <v-card-text class="pa-2">
                              <v-text-field
                                ref="email"
                                name="email"
                                label="Email"
                                filled
                                hint="Obligatorio"
                                persistent-hint
                                placeholder="Ingresa acá una dirección de correo"
                                class="py-3"
                                v-model="email"
                                required
                                :error-messages="emailErrors"
                                @input="$v.email.$touch()"
                                @blur="$v.email.$touch()"
                              />
                              <v-text-field
                                ref="confirmEmail"
                                name="confirmEmail"
                                label="Confirmar Email"
                                filled
                                placeholder="Repite acá la dirección de correo"
                                hint="Obligatorio"
                                persistent-hint
                                class="py-3"
                                v-model="confirmEmail"
                                required
                                :error-messages="confirmEmailErrors"
                                @input="$v.confirmEmail.$touch()"
                                @blur="$v.confirmEmail.$touch()"
                              />
                            </v-card-text>
                            <v-card-actions class="text-center">
                              <v-btn color="info" :loading="loading" button @click="register" :disabled="$v.$invalid || loading" class="btn-main-job">ENVIAR</v-btn>
                            </v-card-actions>
                            <div class="text-center">
                              <p class="error mt-5" v-if="remoteError">{{ remoteError }}</p>
                            </div>
                            <div class="write-us">
                              <p>Recibirás un correo para validar tu mail y crear tu contraseña. <br> ¿No recibes el link?, Haz click <a href="#">aquí</a></p>
                              <p>Si tienes problemas escríbenos directamente a <a href="mailto:hola@trabajoconsentido.com">hola@trabajoconsentido.com</a></p>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row justify="center" class="box-register">
                      <v-dialog v-model="finished" persistent max-width="500">
                        <div class="register-dialog">
                          <v-card class="pa-5 pa-sm-10">
                            <div class="close-dialog">
                              <v-btn color="blue" class="float-right" icon @click="finished = false"><v-icon>mdi-close</v-icon></v-btn>
                            </div>
                            <v-container>
                              <v-row justify="center">
                                <v-col cols="4" md="3" lg="4">
                                  <v-img src="@/assets/images/logo-tcs.webp" />
                                </v-col>
                                <v-col cols="12" align="center" class="pa-0">
                                  <h3 class="text-center">Muchas gracias por tu tiempo<br>¡Está casi listo tu registro!</h3>
                                </v-col>
                                <v-col cols="12" sm="9" md="9">
                                  <p class="text-center">Recibirás en unos minutos, un link en tu correo para cambiar tu contraseña.<br> <b>¡Te esperamos acá!</b></p>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </div>
                      </v-dialog>
                    </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-parallax>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";
import { meta } from "@/libs/mixins";

export default {
    name: "ForgetPassword",

    mixins: [validationMixin, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "¿Olvidaste tu contraseña?",
        });
    }, 

    data() {
        return {
            email: "",
            confirmEmail: "",
            errors: [],
            loading: false,
            finished: false
        };
    },

    computed: {
        remoteError() {
            let err = "";
            if (this.errors.length > 0)
                err = this.errors[this.errors.length - 1];
            return err;
        },
        emailErrors() {
            const errors = [];
            if (!this.$v.email.$dirty) return errors;
            !this.$v.email.required && errors.push("Email es requerido");
            return errors;
        },
        confirmEmailErrors() {
            const errors = [];
            if (!this.$v.confirmEmail.$dirty) return errors;
            !this.$v.confirmEmail.sameAsEmail && errors.push("Email deben ser iguales");
            return errors;
        }
    },

    methods: {
        register() {
            this.loading = true;
            this.$store.dispatch("users/forgetPassword", {
                email: this.email
            }).then(() => {
                this.finished = true;
            }).catch(err => {
                this.loading = false;
                this.errors = err;
            });
        }
    },

    validations: {
        email: { required, minLength: minLength(6) },
        confirmEmail: { sameAsEmail: sameAs("email") }
    },
};
</script>
